<template>
  <div class="wrapper" style="height: 100vh; width: 100vw; overflow-x: hidden">
    <!-- cxbdzxbdzb  style="height: 100vh;overflow-x: hidden;"
target	触发滚动的对象	string
right	控制其显示位置, 距离页面右边距	number		40
bottom	控制其显示位置, 距离页面底部距离	number		40
visibility-height	滚动高度达到此参数值才出现	number		200
click	点击按钮触发的事件	点击事件
background-color: #f2f5f6;
box-shadow: 0 0 6px rgba(0,0,0, 0.92);
-->
    <!-- 回到顶部 -->
    <el-backtop
    style=" background-color:rgb(255 255 255 / 0%);"
      target=".wrapper"
      :right="-30"
      :bottom="30"
      :visibility-height="300"
    >
      <div
        style="
           {
            height: 100%;
            width: 100%;
            text-align: center;
            line-height: 0px;
            color: #1989fa;
            .el-icon-caret-top {
              color: #fff;
              display: block;
              width: 100%;
              line-height: 40px;
              text-align: center;
              font-size: 39px;
              margin-left: -110px;
            }
          }
        "
      >
        <i class="el-icon-caret-top"></i>
      </div>

      <!-- icon="el-icon-caret-top" <i class="el-icon-caret-top" title="回到顶部"   ></i> -->
      <!-- <div
      style="{
        height: 100%;
        width: 100%;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1989fa;
      }"
    >
      回到顶部
    </div> -->
      <!--                      <i class="el-icon-caret-top" title="回到顶部" style="width: 50px; height: 50px;" ></i> -->
      <!-- overflow: hidden; -->
      <!-- padding: 15px; -->
      <!-- box-shadow: 0 0 6px rgba(0,0,0, 0.82); -->
      <!-- border: 1px solid #DDDDDD;
border-radius: 50%;
background: red url(../../../assets/icon_sw/el-backtop.svg) center center no-repeat;
-->
      <!-- <div title="回到顶部"


style="{

height: 100%;
width: 100%;
        text-align: center;
padding: 0px;
 box-shadow: 0 0 6px rgba(0,0,0, 0.82);
border-radius: 50%;

}"
> -->

      <!-- <i style="{ margin: 100px; }"  class="el-icon-caret-top" >&nbsp;</i> -->
      <!-- <i class="el-icon-caret-top" title="回到顶部" style="{ width: 100%; height:  ;}"    ></i> -->
      <!--  </div> -->
    </el-backtop>
    <!-- 回到顶部 end -->
    <!--  -->
    <!-- <div class="my_header_height"></div> -->

    <!-- 首页轮播图-pc -->
    <div class="pc-item">
      <v-banner
        v-if="banner_lists.length > 0"
        :vbannerlists="banner_lists"
        vbannerlistsheight="300px"
      ></v-banner>
    </div>

    <div class="mobile-item mobile_search_bar">
      <input class="mobile_search_input" placeholder="输入搜索内容" @click="$goRoute('search_result')"/>
    </div>

    <!-- //首页轮播图-手机端  12                    $res['data']['result']['banner_lists_mobile'] = []; -->
    <div class="mobile-item">
      <v-mobile-banner
        v-if="banner_lists_mobile.length > 0"
        :vbannerlists="banner_lists_mobile"
        vbannerlistsheight="250px"
      ></v-mobile-banner>
    </div>

    <div class="pc-item dangw">
      <img class="123" :src="top_banner_img" alt="" />
    </div>
    <div class="mobile-item dangw_mobile">
      <img class="123" :src="top_banner_img_mobile" alt="" />
    </div>
    <v-head
      :site.sync="site"
      :navigation_lists.sync="navigation_lists"
    ></v-head>
    <!--        <v-sidebar></v-sidebar> -->
    <!--        <div class="content-box" :class="{'content-collapse':collapse}">
            <v-tags></v-tags>
            <div class="content">
                <transition name="move" mode="out-in">
                    <keep-alive :include="tagsList">
                        <router-view></router-view>
                    </keep-alive>
                </transition>
            </div>
        </div> -->

    <div class=" ">
      <transition name="move" mode="out-in">
        <keep-alive :include="tagsList">
          <router-view></router-view>
        </keep-alive>
      </transition>
    </div>

    <div class="clearfix"></div>
<div class="footer-box">
  <div class="pc-item">
      <v-footer
        :site.sync="site"
        :navigation_lists_footer.sync="navigation_lists_footer"
      ></v-footer>
    </div>
    <div class="clearfix"></div>
    <div class="pc_copy_right">
      <!--       <div class="clearfix">   </div> -->

      <v-copyright :site.sync="site"></v-copyright>
      <div class="clearfix"></div>
      <!--  <v-supported></v-supported> -->
    </div>
</div>
  

    <!-- <el-button
    plain
    @click="open1">
    成功
  </el-button>
  <el-button
    plain
    @click="open2">
    警告
  </el-button>
  <el-button
    plain
    @click="open3">
    消息
  </el-button>
  <el-button
    plain
    @click="open4">
    错误
  </el-button> -->
  </div>
</template>

<script>
import Index from "@/components/model/index/index";
import vBanner from "@/components/page/tmp/pc/banner.vue";
import vMobileBanner from "@/components/page/tmp/mobile/banner.vue";
import vHead from "@/components/page/tmp/pcHeader.vue";
import vFooter from "@/components/page/tmp/pcFooter.vue";
import Storage from "@/components/libs/storage";
import Site from "@/components/model/site/site";
import Navigation from "@/components/model/navigation/navigation";
import vCopyright from "@/components/page/tmp/Copyright.vue";
import vSupported from "@/components/common/supported.vue";

import bus from "@/components/common/bus";
export default {
  data() {
    return {
      tagsList: [],
      collapse: false,
      banner_lists: [
        // {
        //   img:'https://gggl.zzkj0898.com/images/code/public/uploads/banner/b-03.png',
        //    href:'https://www.sina.cn',
        //   name:'这是公司的模块广告',
        //   target:'_blank',
        // },
      ],
      banner_lists_mobile: [],
      top_banner_img: "",
      top_banner_img_mobile: "",
      site: {
        logo: 0, //require('@/assets/logo.png'),
        logo_path: "", //require('@/assets/logo.png'),
        name: "",
        tel: "0898-88888888",
        //  tel_icon:require('@/assets/images/header_tel_slices/tel.png'),

        //   'logo':require('@/assets/logo.png'),
        // 'tel':'',
        //  'tel_icon':require('@/assets/images/footer_tel_slices/tel.png'),

        tel_icon: "", //require('@/assets/images/header_tel_slices/tel.png'),
        address: "",
        fax: "",
        email: "",
      },
      navigation_lists: [
        {
          url: "/",
          target: "_self",
          name: "首页",
          sub_lists: [],
        },
      ],
      navigation_lists_footer: [
        {
          url: "/",
          target: "_self",
          name: "首页",
          sub_lists: [],
        },
      ],
    };
  },
  components: {
    vBanner,
    vMobileBanner,
    vHead,
    vFooter,
    //  vSidebar,
    vCopyright,
    vSupported, //vTags,
  },
  created() {
    const that = this;
    // bus.$on('collapse', msg => {
    //     this.collapse = msg;
    // })

    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    // bus.$on('tags', msg => {
    //     let arr = [];
    //     for(let i = 0, len = msg.length; i < len; i ++){
    //         msg[i].name && arr.push(msg[i].name);
    //     }
    //     this.tagsList = arr;
    // })

    //   this.open1()
    that.get_all_data();
    that.get_site();
    that.get_navigation_main_lists();
    that.get_navigation_footer_lists();
  },

  methods: {
    get_all_data() {
      const that = this;
      let _post = {};
      _post.article_category_id = that.article_category_id;

      Index.get_all_data(_post)
        .then((res) => {
          if (res.status === 1) {
            // console.log(res, "res---------------王予乐");

            //首页轮播图-pc
            that.banner_lists = [];
            res.data.result.banner_lists.forEach((item, index) => {
              that.banner_lists.push({
                name: item.name,
                img: item.cover_path,
                href: item.gotourl,
                target: item.target || "_blank",
              });
            });

            //首页轮播图-手机端  12    $res['data']['result']['banner_lists_mobile'] = [];
            that.banner_lists_mobile = [];
            if (res.data.result.banner_lists_mobile !== undefined) {
              res.data.result.banner_lists_mobile.forEach((item, index) => {
                that.banner_lists_mobile.push({
                  name: item.name,
                  img: item.cover_path,
                  href: item.gotourl,
                  target: item.target || "_blank",
                });
              });
            }
            // 党图-sj
            that.top_banner_img = res.data.result.banner_lists_15[0].cover_path;
            // 党图-pc
            that.top_banner_img_mobile =
              res.data.result.banner_lists_15[1].cover_path;
          } else {
            console.info(res);
          }
        })
        .catch((res) => {
          console.info(res);
        });
    },
    //  // 底部导航 footer_lists
    //sessionStorage - 针对一个 session 的数据存储

    //底部导航
    get_navigation_footer_lists() {
      const that = this;
      if (
        Storage.s_get("navigation_lists_footer") &&
        Storage.s_get("navigation_lists_footer") !== "" &&
        Storage.s_get("navigation_lists_footer").length > 0
      ) {
        let list = Storage.s_get("navigation_lists_footer");
        list.sort(function (a, b) {
          return b["sort"] - a["sort"];
        });
        let __list = [];
        list.forEach((item, index) => {
          item.sub_lists.sort(function (a, b) {
            return b["sort"] - a["sort"];
          });
          __list.push(item);
        });
        that.navigation_lists_footer = __list;
        list = null;
        __list = null;
      } else {
        Navigation.footer_lists({})
          .then((res) => {
            if (res.status == 1) {
              that.navigation_lists_footer.length = 0;
              let list = [];
              let l;
              res.data.result.sort(function (a, b) {
                return b["sort"] - a["sort"];
              });
              res.data.result.forEach((item, index) => {
                if (item.parent_id === 0) {
                  l = {
                    url: item.url,
                    target: "_self",
                    name: item.name,
                    sort: item.sort,
                    sub_lists: [],
                  };
                  res.data.result.forEach((sub_item, sub_index) => {
                    if (item.id === sub_item.parent_id) {
                      l.sub_lists.push({
                        url: sub_item.url,
                        sort: sub_item.sort,
                        target: sub_item.target || "_self",
                        name: sub_item.name,
                      });
                    }
                  });
                  l.sub_lists.sort(function (a, b) {
                    return b["sort"] - a["sort"];
                  });
                  list.push(l);
                }
              });
              that.navigation_lists_footer = list;
              Storage.s_set("navigation_lists_footer", list, 10000);
              list = null;
            } else {
              console.info("err");
            }
          })
          .catch((res) => {
            console.info("底部导航", res);
          });
      }
    },

    //   主导航 main_lists
    get_navigation_main_lists() {
      const that = this;
      if (
        Storage.s_get("navigation_lists_header") &&
        Storage.s_get("navigation_lists_header") !== "" &&
        Storage.s_get("navigation_lists_header").length > 0
      ) {
        let list = [];
        list = Storage.s_get("navigation_lists_header");
        list.sort(function (a, b) {
          return b["sort"] - a["sort"];
        });
        let __list = [];
        list.forEach((item, index) => {
          item.sub_lists.sort(function (a, b) {
            return b["sort"] - a["sort"];
          });
          __list.push(item);
        });
        that.navigation_lists = __list;
        list = null;
        __list = null;
      } else {
        Navigation.main_lists({})
          .then((res) => {
            console.log(res, "导航数据 --- 666");
            if (res.status == 1) {
              that.navigation_lists.length = 0;
              let list = [];
              let l;
              res.data.result.sort(function (a, b) {
                return b["sort"] - a["sort"];
              });
              res.data.result.forEach((item, index) => {
                if (item.parent_id === 0) {
                  l = {
                    className: "pc_sub_navigation_hover_style_" + index,
                    url: item.url,
                    sort: item.sort,
                    target: item.target || "_self",
                    name: item.name,
                    sub_lists: [],
                  };
                  res.data.result.forEach((sub_item, sub_index) => {
                    if (item.id === sub_item.parent_id) {
                      l.sub_lists.push({
                        className: "pc_sub_navigation_hover_style_" + sub_index,
                        url: sub_item.url,
                        sort: sub_item.sort,
                        target: sub_item.target || "_self",
                        name: sub_item.name,
                      });
                    }
                  });
                  l.sub_lists.sort(function (a, b) {
                    return b["sort"] - a["sort"];
                  });
                  list.push(l);
                }
              });
              that.navigation_lists = list;
              Storage.s_set("navigation_lists_header", list, 10000);
              list = null;
            } else {
              console.info("ERR", res);
            }
          })
          .catch((res) => {
            console.info("导航", res);
          });
      }
    },

    //sessionStorage - 针对一个 session 的数据存储
    get_site() {
      console.info("/pc_code/source_code/src/components/page/tmp/main.vue");
      const that = this;
      if (Storage.s_getItem("site") && Storage.s_getItem("site") !== "") {
        let _site = Storage.s_getItem("site");
        _site.tel_icon = require("@/assets/images/header_tel_slices/tel.png");
        that.site = _site;
      } else {
        console.log("Site err112  pcHeader.vue");
        Site.info({})
          .then((res) => {
            if (res.status == 1) {
              Storage.s_setItem("site", res.data.result);
              let _site = res.data.result;
              _site.tel_icon = require("@/assets/images/header_tel_slices/tel.png");
              that.site = _site;
            }
          })
          .catch((res) => {
            console.info("Site.info", res);
          });
      }
    },

    open1() {
      this.$notify({
        title: "成功",
        message: "欢迎您",
        type: "success",
        position: "bottom-right",
      });
    },

    open2() {
      this.$notify({
        title: "警告",
        message: "这是一条警告的提示消息",
        type: "warning",
        position: "bottom-right",
      });
    },

    open3() {
      this.$notify.info({
        title: "消息",
        message: "这是一条消息的提示消息",
        position: "bottom-right",
      });
    },

    open4() {
      this.$notify.error({
        title: "错误",
        message: "这是一条错误的提示消息",
        position: "bottom-right",
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/page/tmp/main.vue